import { FC, FunctionComponent, SVGProps } from "react";
import { useTranslation } from "react-i18next";

import Instant from "@/assets/friendsWithBenefits/benefitInstant.svg?react";
import Saving from "@/assets/friendsWithBenefits/benefitSaving.svg?react";
import Viral from "@/assets/friendsWithBenefits/benefitViral.svg?react";
import { TranslationKey } from "@/utils/translationKey";

type Benefit = {
  Illustration: FunctionComponent<SVGProps<SVGSVGElement>>;
  titleKey: TranslationKey;
  textKey: TranslationKey;
};

const benefits: Benefit[] = [
  {
    Illustration: Saving,
    titleKey: "friendsWithBenefits.welcome.benefits.saving.title",
    textKey: "friendsWithBenefits.welcome.benefits.saving.text",
  },
  {
    Illustration: Instant,
    titleKey: "friendsWithBenefits.welcome.benefits.instant.title",
    textKey: "friendsWithBenefits.welcome.benefits.instant.text",
  },
  {
    Illustration: Viral,
    titleKey: "friendsWithBenefits.welcome.benefits.viral.title",
    textKey: "friendsWithBenefits.welcome.benefits.viral.text",
  },
];

/** The three selling points below the welcome greeting. */
export const WelcomeBenefits: FC = () => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col items-start gap-gutter desktop:flex-row">
      {benefits.map(({ Illustration, titleKey, textKey }) => (
        <div
          key={titleKey}
          className="flex flex-1 flex-col items-center gap-3 px-6 text-center text-foreground-primary"
        >
          <Illustration className="size-14" />
          <p className="text-body-lg font-semibold leading-md">{t(titleKey)}</p>
          <p className="text-body-base leading-md">{t(textKey)}</p>
        </div>
      ))}
    </div>
  );
};
